define([
	"dojo/_base/declare",
	"csi/action/EditController",
	"Apparel/StructureItemActionMixin"
], function(declare,EditController,StructureItemActionMixin) {

	return declare([EditController, StructureItemActionMixin], {
		/**
		 * Add special controller for edit form
		 */
		onCreatePopupDefView: function(defView) {
			this._mixinActionView(defView);
		}
	});
});